import React, { useState, useEffect, lazy, Suspense } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';

// Lazy load components
const Services = lazy(() => import('./components/Services'));
const Pricing = lazy(() => import('./components/Pricing'));
const About = lazy(() => import('./components/About'));
const Gallery = lazy(() => import('./components/Gallery'));
const GalleryPage = lazy(() => import('./components/GalleryPage'));
const Booking = lazy(() => import('./components/Booking'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));
const SEOContent = lazy(() => import('./components/SEOContent'));
import { useLanguage } from './hooks/useLanguage';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const { language } = useLanguage();

  // Update document language when language changes
  useEffect(() => {
    document.documentElement.lang = language;
    
    // Update page title based on language
    const title = language === 'sr' 
      ? 'Hot Dogs - Salon za pse | Frizerski salon za pse Beograd | Šišanje i grooming'
      : 'Hot Dogs - Dog Grooming Salon | Professional Pet Grooming Belgrade';
    document.title = title;
  }, [language]);

  const renderPage = () => {
    const content = currentPage === 'gallery' ? (
      <GalleryPage setCurrentPage={setCurrentPage} />
    ) : (
      <>
        <Hero />
        <Services />
        <Pricing />
        <About />
        <Gallery setCurrentPage={setCurrentPage} />
        <Booking />
        <Contact />
      </>
    );

    return (
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
        </div>
      }>
        {content}
      </Suspense>
    );
  };

  return (
    <div className="min-h-screen">
      <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {renderPage()}
      <Suspense fallback={<div className="h-40"></div>}>
        <Footer setCurrentPage={setCurrentPage} />
      </Suspense>
      <Suspense fallback={null}>
        <SEOContent />
      </Suspense>
    </div>
  );
}

export default App;